import React, { useState, useEffect } from 'react'
import { Cascader, Select, Form, Button, Row, DatePicker, message, Upload, Input, Radio } from "antd"
import { UploadOutlined } from '@ant-design/icons';
const { TextArea } = Input
const { Option } = Select
import AddModal from '@components/Modal'
import moment from 'moment';
import stationApi from '@api/station'
import DepartmentApi from '@api/department'
import InspectionApi from '@api/inspectionnew'
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
}
export default ({ title, visible, formData = null, cancel, stationData }) => {
  const [form] = Form.useForm() // 表单
  const [loading, setLoading] = useState()  // 加载
  const [deptList, setDeptList] = useState([])  // 部门
  const [imageUrls, setImageUrls] = useState([])  // 上传图片
  const [deviceLs, setDeviceLs] = useState([])    // 缺陷设备
  const [defectslevelLs, setDefectslevelLs] = useState([])  // 缺陷等级列表
  const [personList, setPersonList] = useState([])  // 部门负责人
  const [personParams, setPersonParams] = useState({
    stationId: 0,
    deptId: 0
  })

  useEffect(() => {
    defectList()
    getDept()
  }, [])

  useEffect(() => {
    if (personParams.stationId && personParams.deptId) {
      getPersonList()
    }
  }, [personParams])

  // 获取缺陷等级列表
  const defectList = () => {
    InspectionApi.defectLevel({ pageNum: 1, pageSize: 100000 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setDefectslevelLs(res.data.data)
      }
    })
  }

  // 获取部门列表
  const getDept = async () => {
    const res = await DepartmentApi.getDeptForTree({})
    if (!res.status) return
    const dept = res.data
    setDeptList(dept)
  }

  // 切换部门
  const changeDept = (e) => {
    if (!e) return
    let params = personParams
    params.deptId = e[e.length - 1]
    setPersonParams({
      ...params
    })
  }

  // 获取部门负责人
  const getPersonList = () => {
    form.setFieldsValue({ deptLeaderId: null })
    DepartmentApi.getDeptHeadersByDeptId(personParams).then(res => {
      if (res.status !== '0') return
      setPersonList(res.data)
    })
  }

  // 切换厂站
  const changStation = (e) => {
    stationApi.getDeviceByStationId({ stationId: e }).then(res => {
      if (res.status !== '0') return
      setDeviceLs(res.data)
    })
    let params = personParams
    params.stationId = e
    setPersonParams({
      ...params
    })
  }

  // 上传前进行图片限制处理
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('图片格式不正确!');
    }
    const isLt2M = file.size / 1024 / 1024 < 7;
    if (!isLt2M) {
      message.error('图片最大7M!');
    }
    return isJpgOrPng && isLt2M;
  }

  // 上传图片
  const uploadResultImg = (info) => {
    const { file } = info
    if (file.status === 'done') {
      const { response: res } = file
      if (res.status !== '0') return
      setImageUrls([...imageUrls, res.data.url])
    }
  }

  // 移除图片
  const removeResultImg = (info) => {
    const { response: res } = info
    const url = res.data.url
    const params = imageUrls
    const index = params.findIndex(item => item === url)
    params.splice(index, 1)
    setImageUrls([...params])
  }

  // 提交
  const submit = () => {
    form.validateFields().then(values => {
      if (!values) {
        return;
      }
      setLoading(true)
      const params = JSON.parse(JSON.stringify(values))
      params.discoveryTime = moment(params.discoveryTime).format('YYYY-MM-DD HH:mm:ss')
      params.planCloseTime = moment(params.planCloseTime).format('YYYY-MM-DD HH:mm:ss')
      params.deviceRelevancyId = params.deviceRelevancyId[params.deviceRelevancyId.length - 1]
      params.insertType = 1
      // params.sourceType = 0
      params.deptId = params.deptId[params.deptId.length - 1]
      params.imageUrls = imageUrls
      if (formData && formData.id) {

      } else {
        InspectionApi.defectAdd(params).then(res => {
          if (res.status == 0) {
            message.success('添加成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      }
    })
  }
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form
          {...layout}
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
        >
          <Form.Item
            label='巡检厂站'
            name="stationId"
            rules={[{ required: true, message: '请选择巡检厂站' }]}
          >
            <Select
              allowClear
              onChange={(val) => changStation(val)}
              placeholder="请选择巡检厂站">
              {
                stationData && stationData.map((item, idx) => {
                  return (
                    <Option value={item.value} key={'stationId-' + idx}>{item.title || item.name}</Option>
                  )
                })
              }
            </Select>
          </Form.Item>
          <Form.Item label="巡检设备" name="deviceRelevancyId" rules={[{ required: true, message: '请选择巡检设备' }]}>
            <Cascader
              fieldNames={{
                label: 'itemName',
                value: 'id',
                children: 'child',
              }}
              options={deviceLs}
              placeholder="请选择设备"
            />
          </Form.Item>
          <Form.Item
            label='缺陷等级'
            name='defectLevelId'
            rules={[{ required: true, message: '请选择缺陷等级' }]}
          >
            <Select placeholder={'请选择缺陷等级'}>
              {
                defectslevelLs && defectslevelLs.map(item => {
                  return <Option value={item.id} key={item.id}>{item.defectLevelName}</Option>
                })
              }
            </Select>
          </Form.Item>
          <Form.Item label='负责部门' name="deptId" rules={[{ required: true, message: '请选择负责部门' }]}>
            <Cascader
              fieldNames={{
                label: 'name',
                value: 'id',
                children: 'children',
              }}
              options={deptList}
              onChange={(e) => { changeDept(e) }}
              placeholder="请选择负责部门"
            />
          </Form.Item>
          <Form.Item label='部门负责人' name="deptLeaderId" rules={[{ required: true, message: '请选择部门负责人' }]}>
            <Select placeholder={'请选择部门负责人'}>
              {
                personList && personList.map(item => {
                  return <Option value={item.id} key={item.id}>{item.realName}</Option>
                })
              }
            </Select>
          </Form.Item>
          <Form.Item
            label='是否安全隐患'
            name='safetyPerilFlag'
            rules={[{ required: true, message: '请选择是否安全隐患!' }]}
          >
            <Radio.Group>
              <Radio value={0}>否</Radio>
              <Radio value={1}>是</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label='发现时间'
            name='discoveryTime'
            rules={[{ required: true, message: '请选择发现时间!' }]}
          >
            <DatePicker
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
            />
          </Form.Item>
          <Form.Item
            label='计划关闭时间'
            name='planCloseTime'
            rules={[{ required: true, message: '请选择计划关闭时间!' }]}
          >
            <DatePicker
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
            />
          </Form.Item>
          <Form.Item
            label='缺陷描述'
            name="deffectRemark"
            rules={[{ required: true, message: '请输入缺陷描述' }]}
          >
            <TextArea rows={4} placeholder="请输入缺陷描述" />
          </Form.Item>
          <Form.Item
            label='上传图片'
          >
            <Upload
              name='file'
              action={window.globalConfig.UPLOADER}
              headers={{ authorization: sessionStorage.getItem('token') }}
              beforeUpload={(e) => beforeUpload(e)}
              onChange={(e) => uploadResultImg(e)}
              onRemove={e => removeResultImg(e)}
            >
              <Button icon={<UploadOutlined />}>上传图片</Button>
            </Upload>
          </Form.Item>
        </Form>
      </div>
    </AddModal>
  )

}
